<article class="text-center">
  <h2 class="text-info">Page not found!</h2>
  <div>Sorry, the page you are looking for could not be found </div>
</article>